import { Badge } from "./badge";
import { CheckIcon } from "./icons/check-icon";
import { AlertIcon } from "./icons/alert-icon";

type Props = {
  label: string;
  status: "success" | "error";
};

/**
 * Simplified status badge that automatically selects variant and icon based on status.
 */
export const StatusBadge = ({ label, status }: Props) => (
  <Badge
    label={label}
    variant={status === "success" ? "lightGreen" : "error"}
    icon={status === "success" ? CheckIcon : AlertIcon}
  />
);
